export const loadBusinessRouter = () => import('@/app/router/router-business')
export const loadClientsRouter = () => import('@/features/clients/router/router-clients')
export const loadCreditsRouter = () => import('@/features/credits/credits.routes')
export const loadDeliveriesRouter = () =>
  import('@/features/deliveries/components/router-deliveries')
export const loadInventoryRouter = () => import('@/features/inventory/routers/inventory.router')
export const loadNegotiationsRouter = () =>
  import('@/features/negotiations/components/router-negotiations')

const ADMIN_ROUTE_PRELOADERS: Record<string, (() => Promise<unknown>) | undefined> = {
  business: loadBusinessRouter,
  clients: loadClientsRouter,
  creditos: loadCreditsRouter,
  deliveries: loadDeliveriesRouter,
  inventory: loadInventoryRouter,
  negotiations: loadNegotiationsRouter
}

/**
 * Preloads only after navigation intent; dynamic imports are cached by the browser.
 *
 * El fallo se traga a propósito. Esto corre al pasar el mouse, y el usuario todavía no pidió ir
 * a ningún lado: un chunk que ya no existe —el caso normal después de un despliegue— generaría
 * una promesa rechazada sin dueño, que termina en Sentry como si algo se hubiera roto cuando en
 * realidad no se rompió nada visible. Si después hace clic de verdad, `lazy` lo carga con
 * `retryImport`, y AHÍ sí corresponde recuperarse recargando.
 */
export function preloadAdminRoute(segment: string) {
  return ADMIN_ROUTE_PRELOADERS[segment]?.().catch(() => undefined)
}
